import React from 'react';
import ReactDOM from 'react-dom';
import Display from '../parts/display';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as siteActions from '../../actions/siteActions';
import _find from 'lodash/find';
import { browserHistory, Link } from 'react-router';
import ClientsBlock from '../clientsBlock';
import BlogBlock from '../blogBlock';
import Scroll, {Element, scroller}  from 'react-scroll';


class ServicesPage extends React.Component {
	constructor() {
		super();
		this.state = {
			animated: false

		};

		this.setSelectedService = this.setSelectedService.bind(this);
		this.getSkillsets = this.getSkillsets.bind(this);
		this.getSpecialisms = this.getSpecialisms.bind(this);
	}
	componentDidMount() {
		this.props.actions.showNavBar(true);
		this.props.actions.showMenu(true);
		if(this.props.site.posts.length < 1){
			this.props.actions.loadBlogPosts(3,1);
		}
		if((this.props.location.pathname.match(/\//g) || []).length == 2){
			let name = this.props.location.pathname.substring(10, this.props.location.pathname.length);
			this.setSelectedService(name);
		}
	}
	componentWillReceiveProps(nextProps){
		if(nextProps.location.pathname === "/services"){
			window.scrollTo(0,0);
		}
	}
	componentWillMount(){
		window.scrollTo(0,0);
	}
	componentWillUnmount(){
		this.props.actions.clearState();
	}
	setSelectedService(e){
		// this.props.actions.selectService(e.currentTarget.getAttribute('data-slug'));
		// console.log(_find(this.props.site[e.currentTarget.getAttribute('data-id') + 's'], {slug: e.currentTarget.getAttribute('data-slug')}));
		if(typeof e  === 'object'){
			this.props.actions.loadService(_find(this.props.site[e.currentTarget.getAttribute('data-id') + 's'], {slug: e.currentTarget.getAttribute('data-slug')}));
		}else{
			if(_find(this.props.site.specialisms, {slug: e})){
				this.props.actions.loadService(_find(this.props.site.specialisms, {slug: e}));
			}else if(_find(this.props.site.skillsets, {slug: e})){
				this.props.actions.loadService(_find(this.props.site.skillsets, {slug: e}));
			}
		}
		// if(this.props.site.selectedService !== false){
			scroller.scrollTo('scrollToService', {
				duration: 1000,
				delay: 0,
				smooth: true
			});
		// }
	}
	getSpecialisms(s,i){
		return <li key={i} onClick={this.setSelectedService} data-slug={s.slug} data-id={s.taxonomy}><Link to={"/services/" + s.slug} activeClassName="active"><i>/</i><span dangerouslySetInnerHTML={{__html: s.name}}></span></Link></li>
	}
	getSkillsets(s,i){
		return <li key={i} onClick={this.setSelectedService} data-slug={s.slug} data-id={s.taxonomy}><Link to={"/services/" + s.slug} activeClassName="active"><i>/</i><span dangerouslySetInnerHTML={{__html: s.name}}></span></Link></li>
	}
	render() {
		return (
			<div className="services-page animated fadeIn">
				<div className="grey-section">
					<div className="container">
						<div className="row">
							<h1><span>/</span> Services</h1>
							<div className="dash-separator"></div>
							<div className="col-md-6">
								<h3 className="no-dash">By Specialism</h3>
								<ul className="service-list">
									{this.props.site.specialisms.map(this.getSpecialisms)}
								</ul>
							</div>
							<div className="col-md-6">
								<h3 className="no-dash">By Skillset</h3>
								<ul  className="service-list">
									{this.props.site.skillsets.map(this.getSkillsets)}
								</ul>
							</div>
						</div>
					</div>
				</div>
				<Element name="scrollToService" />
				{this.props.children}
				<Display if={this.props.site.selectedPortfolios.length > 1}>
					<ClientsBlock clients={this.props.site.selectedClients}/>
					<BlogBlock posts={this.props.site.posts}  maxPosts={3} />
				</Display>
			</div>
		);
	}
}
function mapStateToProps(state, ownProps) {
	return {
		site: state.site
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(siteActions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ServicesPage);



/** WEBPACK FOOTER **
 ** ./src/js/components/services/servicesPage.js
 **/